export const getSearchUrl = (
    procedureId,
    specialtyId,
    insuranceCarrierId,
    insurancePlanId,
    whiteLabelVanityUrl
) => {
    return (
        (whiteLabelVanityUrl ? `/wl/${whiteLabelVanityUrl}` : '') +
        `/search?reason_visit=${procedureId}` +
        `&dr_specialty=${specialtyId}` +
        `&insurance_carrier=${insuranceCarrierId}` +
        `&insurance_plan=${insurancePlanId}`
    );
};
